import React, {useState, useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { withRouter } from "react-router";

import {Copyright} from '../../../components';

import { useFormik } from 'formik';

import {confirmEmail, logoutUser, resendEmailConfirmation} from '../../../services/auth.service';
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import {LOCAL_STORAGE_KEYS, TOAST_TYPES} from "../../../utils/constants";
import {useAuth} from "../../../context/auth";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {useLocation} from "react-router-dom";
import {toast} from "../../../utils/utils";
import {FormControl} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    pageWrapper: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--brand-bg, #f4eeee)',
    },
    paper: {
        width: '100%',
        maxWidth: '545px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 'auto',
        marginTop: 'auto',
        padding: '20px',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#777',
    },
    form: {
        width: '82%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: '#0397a6 !important',
        color: '#ffffff !important',
        borderRadius: '7px !important',
        height: '50px !important',
        fontSize: '16px !important',
        fontWeight: '800 !important',
        textTransform: 'uppercase !important',
        boxShadow: 'none !important',
        '&:hover': {
            backgroundColor: '#0397a6 !important',
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    inputField: {
        marginBottom: theme.spacing(3),
        width: "100%",
        '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: 'transparent',
            '& fieldset': {
                border: '2px solid #e5e5e5',
            },
            '&:hover fieldset': {
                border: '2px solid #e5e5e5',
            },
            '&.Mui-focused fieldset': {
                border: '2px solid #FFAB46',
            },
        },
        '& .MuiInputBase-input': {
            color: 'var(--brand-text, #333)',
        },
        '& .MuiInputLabel-root': {
            color: '#929EA7',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#FFAB46',
        },
    },
    footerContainer: {
        marginTop: 'auto',
        paddingBottom: '10px',
        width: '100%',
        textAlign: 'center',
    },
    linkContainer: {
        marginTop: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    link: {
        color: 'var(--brand-text, #333) !important',
        fontWeight: '600 !important',
        textDecoration: 'none !important',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline !important',
        },
    },
}));

const ConfirmEmail = (props) => {

    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [resendLinkEnable, setResendLinkEnable] = useState(false)

    const { setAuthToken, setAuthUser } = useAuth();

    const location = useLocation();

    useEffect( ()=> {
        setTimeout( () => {
            setResendLinkEnable(true);
        }, 9000)
        const params = new URLSearchParams(location.search);
        const url_token = params.get('token');
        if(url_token) {
            validateToken(url_token).then(() => `successfully logged in to application using token`)
        }
    }, [])

    async function validateToken(token) {
        setLoading(true);
        try {
            const result = await confirmEmail(token);
            console.log('result.data -> ', result.data);

            if (result.data && result.data.user) {
                setAuthUser(result.data.user)
            }

            toast(TOAST_TYPES.SUCCESS, "Confirmed", "Successfully Confirmed the Email Address")
            // redirect to next logic page
            const redirectTo = '/my_workspace';
            setTimeout( ()=>{
                props.history.push(redirectTo, { userMessage: location.state?.userMessage });
            }, 300);
        } catch (e) {
            // already toasted the error
        }
        setLoading(false)
    }

    const formik = useFormik({
        initialValues: {
            ver_code: ''
        },
        onSubmit: async (values) => {
            console.log('Form data => ', values);
            await validateToken(values.ver_code);
        }
    });

    const handleLogout = async () => {
        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_user);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.refresh_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.user_email);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.dqpro_v2_google_auth_redirect);
            // history.push('/login');
        } catch (e) {
            // already toasted the error
        }
    };

    const resendVerificationCode = async () => {

        setLoading(true);

        try {
            const result = await resendEmailConfirmation();
            console.log('result.data -> ', result.data);

            toast(TOAST_TYPES.SUCCESS, "Code Resent", "Successfully sent code to your email address")
        }
        catch (e) {
            // already toasted the error
        }

        setLoading(false);
    }

    return (
        <div className={classes.pageWrapper}>
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography variant="h2" className={classes.title} sx={{ mb: 4 }}>
                    Enter Confirmation Token
                </Typography>
                <Typography style={{marginTop:'15px', color: 'var(--brand-text-muted, #333)', fontWeight: '500'}} >
                    Please check your email as we have just sent the token.
                </Typography>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <FormControl
                        fullWidth
                        variant="outlined"
                        className={classes.inputField}
                    >
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="ver_code"
                        label="Confirmation Token"
                        name="ver_code"
                        autoComplete="ver_code"
                        autoFocus
                        onChange={formik.handleChange}
                        value={formik.values.ver_code}
                    />
                    </FormControl>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className={classes.submit}
                    >
                        Submit
                    </Button>

                    <div className={classes.linkContainer}>
                        <Link onClick={handleLogout} className={classes.link} variant="body2">
                            Logout
                        </Link>
                        {
                            resendLinkEnable && (
                                <Link onClick={resendVerificationCode} className={classes.link} variant="body2">
                                    Resend Code?
                                </Link>
                            )
                        }
                    </div>

                </form>
            </div>
            <div className={classes.footerContainer}>
                <Copyright />
            </div>

            <LoaderWithBackDrop loading={loading} />

        </div>
    );
}

export default withRouter(ConfirmEmail);